import {
    GET_BLOCKED_START,
    GET_BLOCKED_SUCCESS,
    GET_BLOCKED_ERROR
} from '../../constants';
import { userListingForDates as query, listingDataUpdate as mutation } from '../../lib/graphql';

export function getListBlockedDates(
    listId,
    minNightValues,
    maxNightValues,
    checkInEndValue,
    checkInStartValue,
    houseRules,
    isCancel,
    isMaxDays,
    isBooking,
    basePrice,
    cleaningPrice,
    currency,
    tax,
    weeklyDiscount,
    monthlyDiscount
) {

    return async (dispatch, getState, { client }) => {
        dispatch({
            type: GET_BLOCKED_START,
        });

        try {
            const { data } = await client.mutate({
                mutation,
                variables: {
                    id: Number(listId),
                    minNight: minNightValues,
                    maxNight: maxNightValues,
                    checkInStart: checkInStartValue,
                    checkInEnd: checkInEndValue,
                    houseRules,
                    cancellationPolicy: Number(isCancel),
                    maxDaysNotice: isMaxDays,
                    bookingNoticeTime: String(isBooking),
                    basePrice: parseFloat(basePrice),
                    cleaningPrice: parseFloat(cleaningPrice),
                    currency,
                    tax: parseFloat(tax),
                    weeklyDiscount: Number(weeklyDiscount),
                    monthlyDiscount: Number(monthlyDiscount)
                },
                refetchQueries: [{ query, variables: { listId: Number(listId), preview: true } }]
            });

            if (data?.ListingDataUpdate) {
                if (data.ListingDataUpdate.status === 'success') {
                    dispatch({
                        type: GET_BLOCKED_SUCCESS,
                    });
                    return true;
                } else {
                    return false;
                }
            }

        } catch (error) {
            dispatch({
                type: GET_BLOCKED_ERROR,
                payload: {
                    error
                }
            });
        }
    };
}